import { GOOGLE_DRIVE } from "../apiConstant";
import BaseApi from "../baseApi";

class GoogleDriveApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_AUTHENTICATION_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  uploadFile(body) {
    return this.post(`${GOOGLE_DRIVE}/upload`, body);
  }

}
export default GoogleDriveApi;
